import React from "react";
import classNames from "classnames";

type Variant = "primary" | "secondary";

interface CommonProps {
  variant?: Variant;
  size?: "default" | "lg";
  className?: string;
  children: React.ReactNode;
}

type AnchorProps = CommonProps & {
  href: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  target?: string;
  rel?: string;
};

type ButtonProps = CommonProps & {
  href?: undefined;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "button" | "submit";
};

type ContentButtonProps = AnchorProps | ButtonProps;

function buildClassName(variant: Variant, size: "default" | "lg", extra?: string): string {
  return classNames(
    "cs-btn",
    variant === "primary" && "cs-btn-primary",
    size === "lg" && "cs-btn-lg",
    extra,
  );
}

const ContentButton: React.FC<ContentButtonProps> = (props) => {
  const { variant = "secondary", size = "default", className, children } = props;
  const cn = buildClassName(variant, size, className);

  if ("href" in props && props.href !== undefined) {
    return (
      <a href={props.href} className={cn} onClick={props.onClick} target={props.target} rel={props.rel}>
        {children}
      </a>
    );
  }

  return (
    <button type={props.type ?? "button"} className={cn} onClick={props.onClick}>
      {children}
    </button>
  );
};

export default ContentButton;
